import { create } from "zustand";
import type { TurnoverItem, TurnoversStats } from "./turnovers-types";
import * as api from "./turnovers-api";

interface TurnoversState {
  items: TurnoverItem[];
  filteredItems: TurnoverItem[];
  stats: TurnoversStats | null;
  query: string;
  loading: boolean;
  fetch: () => Promise<void>;
  setQuery: (q: string) => void;
}

export const useTurnoversStore = create<TurnoversState>((set, get) => ({
  items: [],
  filteredItems: [],
  stats: null,
  query: "",
  loading: false,

  fetch: async () => {
    set({ loading: true });
    try {
      const res = await api.getTurnovers();
      const items = res.accounts || [];
      const stats: TurnoversStats = {
        total_accounts: items.length,
        wb_total: items.reduce((s, a) => s + a.stores.filter(st => st.marketplace === "wildberries").reduce((ss, st) => ss + st.turnover, 0), 0),
        ozon_total: items.reduce((s, a) => s + a.stores.filter(st => st.marketplace === "ozon").reduce((ss, st) => ss + st.turnover, 0), 0),
        grand_total: items.reduce((s, a) => s + a.total_turnover, 0),
      };
      set({ items, filteredItems: items, stats, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  setQuery: (query) => {
    const { items } = get();
    const q = query.toLowerCase();
    const filteredItems = q
      ? items.filter(
          (a) =>
            (a.email && a.email.toLowerCase().includes(q)) ||
            (a.public_login && a.public_login.toLowerCase().includes(q))
        )
      : items;
    set({ query, filteredItems });
  },
}));
